/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Access Administration API
 * OpenAPI spec version: 1.0.0
 */
import * as zod from "zod";

/**
 * @summary Get user access
 */
export const GetAccessAdministrationUserAccessResponse = zod.object({
  userId: zod.uuid(),
  assignedRoles: zod.array(
    zod.object({
      roleId: zod.uuid(),
      name: zod.string(),
      description: zod.string(),
      parentRole: zod
        .union([
          zod.object({
            roleId: zod.uuid(),
            name: zod.string(),
          }),
          zod.null(),
        ])
        .optional(),
      directPermissions: zod.array(
        zod.object({
          permissionKey: zod.string(),
          label: zod.string(),
          description: zod.string(),
          category: zod.string(),
        }),
      ),
      inheritedPermissions: zod.array(
        zod.object({
          permissionKey: zod.string(),
          label: zod.string(),
          description: zod.string(),
          category: zod.string(),
        }),
      ),
      effectivePermissions: zod.array(
        zod.object({
          permissionKey: zod.string(),
          label: zod.string(),
          description: zod.string(),
          category: zod.string(),
        }),
      ),
    }),
  ),
  directPermissionOverrides: zod.array(
    zod.object({
      permission: zod.object({
        permissionKey: zod.string(),
        label: zod.string(),
        description: zod.string(),
        category: zod.string(),
      }),
      effect: zod.enum(["ALLOW", "DENY"]),
    }),
  ),
  effectivePermissions: zod.array(
    zod.object({
      permissionKey: zod.string(),
      label: zod.string(),
      description: zod.string(),
      category: zod.string(),
    }),
  ),
});

/**
 * @summary Assign role to user
 */
export const AssignAccessAdministrationUserRoleBody = zod.object({
  roleId: zod.uuid(),
});

export const AssignAccessAdministrationUserRoleResponse = zod.void();

/**
 * @summary Remove role from user
 */
export const RemoveAccessAdministrationUserRoleResponse = zod.void();

/**
 * @summary Set direct user permission override
 */
export const SetAccessAdministrationUserPermissionOverrideBody = zod.object({
  effect: zod.enum(["ALLOW", "DENY"]),
});

export const SetAccessAdministrationUserPermissionOverrideResponse = zod.void();

/**
 * @summary Remove direct user permission override
 */
export const RemoveAccessAdministrationUserPermissionOverrideResponse = zod.void();
